// Sentry must be initialised BEFORE the React tree mounts so that
// render errors during the first paint are captured. Safe no-op when
// REACT_APP_SENTRY_DSN is unset.
import { initSentry } from "@/lib/sentry";
initSentry();

// PostHog analytics — env-driven, safe no-op when REACT_APP_POSTHOG_KEY /
// REACT_APP_POSTHOG_HOST are unset. Single instance for the whole app.
import { initPostHog } from "@/lib/posthog";
initPostHog();

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
